import BaseModel from './BaseModel'

export default class Customer extends BaseModel {
  // ... Customer-specific methods or overrides ...
}
